import { useNavigate } from 'react-router-dom';

export default function Services() {
  const navigate = useNavigate();

  const services = [
    {
      icon: 'ri-test-tube-line',
      title: 'Lead Inspections & Risk Assessments',
      description: 'Comprehensive lead-based paint testing and risk evaluation for residential and commercial properties, ensuring compliance with federal and state regulations.',
      link: '/lead-inspections',
    },
    {
      icon: 'ri-building-line',
      title: 'Asbestos Surveys & Consulting',
      description: 'Professional asbestos identification and management planning for renovation, demolition, and ongoing facility maintenance projects.',
      link: '/asbestos-surveys',
    },
    {
      icon: 'ri-lungs-line',
      title: 'Indoor Air Quality & Mold',
      description: 'Thorough IAQ testing and mold investigations to identify environmental health concerns and provide actionable remediation recommendations.',
      link: '/indoor-air-quality',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Abatement Design & Management',
      description: 'Expert project specifications, contractor oversight, and bid evaluation to ensure safe, compliant, and cost-effective hazard removal.',
      link: '/abatement-design',
    },
  ];

  const handleLearnMore = (link: string) => {
    navigate(link);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section id="services" className="py-12 sm:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-black mb-3 sm:mb-4">Our Services</h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Comprehensive environmental consulting services to keep your properties safe, compliant, and healthy.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl p-6 sm:p-8 hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-[#f59e0b]"
            >
              <div className="flex items-start mb-6">
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gray-50 text-black rounded-xl flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0 group-hover:bg-[#f59e0b] group-hover:text-white transition-all duration-300">
                  <i className={`${service.icon} text-xl sm:text-2xl`}></i>
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-black mb-2 sm:mb-3">{service.title}</h3>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{service.description}</p>
                </div>
              </div>
              <button
                onClick={() => handleLearnMore(service.link)}
                className="text-[#f59e0b] hover:text-[#d97706] font-semibold transition-colors cursor-pointer flex items-center group text-sm sm:text-base whitespace-nowrap"
              >
                Learn more 
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
